import { Locale, type LocalizedString } from "../Locale.js";

export const productsPathMap = {
	[Locale.cs]: "produkty" as const,
} satisfies LocalizedString;
